<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Ward"
      id="admin_view_ward_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        :to="'/admin/locations/wards/view/' + $route.params.id + '/edit'"
        small
        rounded
        class="mr-4"
        outlined
        color="warning"
      >
        <v-icon left>mdi-pen</v-icon>Edit Ward
      </v-btn>
      <v-btn
        :to="'/admin/locations/wards/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon> Remove Ward
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="ward.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605951043/botswana%20services/website%20assets/ward_w66wvu.png'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Businesses In This Ward"
      id="admin_view_ward_businesses"
    ></CardedSectionHeader>
    <CardedDisplay>
      <CardedTable
        :items="businesses"
        :headers="business_headers"
        :show_description="true"
      >
        <template v-slot:[`item.owner`]="{ item }">
          {{ item.user.first_name }} {{ item.user.last_name }}
        </template>
        <template v-slot:description>
          <p class="text-left ml-4 mr-4">
            This ward has {{ businesses.length }} businesses
          </p>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="view_business(item)"  x-small rounded text color="success">
            <v-icon>mdi-eye</v-icon> 
          </v-btn>
        </template> 
      </CardedTable>
    </CardedDisplay>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedTable from "../../../components/CardedTable";
import ViewHeader from "../../../components/ViewHeader";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminWardsView",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      ward: {
        id: 0,
        name: "",
        country: {
            id: 0,
            name: ""
        },
        district: {
            id: 0,
            name: ""
        },
        city: {
            id: 0,
            name: ""
        }
      },
      businesses: [],
      business_headers: [
        { text: "Name", value: "name" },
        { text: "Phone Number", value: "office_phone_number1", sortable: false  },
        { text: "Owner", value: "owner", sortable: false  },
        { text: "Description", value: "description", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "City",
          val: this.ward.city.name,
        },
        { text: "District:", val: this.ward.district.name },
        { text: "Country:", val: this.ward.country.name },
      ];
      return facts;
    },
  },
  mounted() {
    var ward_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Ward Details",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Wards",
          disabled: false,
          href: "/admin/locations/wards/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/locations/wards/view/" + ward_id,
        },
      ],
    });
    this.$emit("on-show-loader");
    ServerClient.Locations.get_ward(
      {
        id: ward_id,
        is_admin: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.ward = res.ward;
        this.businesses = res.businesses;
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log("Errors while loading ward details on admin", errors);
      }
    );
  },
  methods: {
    view_business(business) {
      this.$router.push("/admin/businesses/view/" + business.id);
    },
  },
};
</script>

<style scoped>
.thumb_div {
  background-color: grey;
  height: 200px;
  width: 200px;
}

.view-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

.view-label {
  /* font- */
}

.view-description-content {
  background-color: #cccccc24;
  height: 80px;
  border-radius: 10px;
  font-size: 16px;
  text-align: left;
  padding: 10px;
  color: #000000c7;
}
</style>